import { useQuery } from '@tanstack/react-query';
import type { OrganisationMembership } from '@ghostscreen/contracts';
import { api } from '../api';
import { useOrganisationId } from '../session';

/** The signed-in user's membership (name, role) in the selected organisation. */
export function useCurrentMembership(): {
  membership: OrganisationMembership | null;
  isPending: boolean;
  isError: boolean;
} {
  const organisationId = useOrganisationId();
  const query = useQuery({
    queryKey: ['my-organisations'],
    queryFn: api.listMyOrganisations,
  });

  return {
    membership: query.data?.find((org) => org.id === organisationId) ?? null,
    isPending: query.isPending,
    isError: query.isError,
  };
}
